import template from './component.tpl.html';
import AlMediaManagerDropZoneController from './controller';

angular
    .module('festzelt-os.modules.media')
    .component('alMediaManagerDropZone', {
        bindings: {
            directoryUuid: '<',
            uploadHidden: '<',
            onUploadSuccess: '&',
            onUploadError: '&',
            triggerFileSelection: '='
        },
        controller: AlMediaManagerDropZoneController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/sub-components/drop-zone/component.js